import Button from 'react-bootstrap/Button';
import './DataBrowsePaginator.css';


function DataBrowsePaginator(props) {
    const { 
        handleClickBegin, handleClickLeft, 
        handleClickRight, handleClickEnd,
        activePage, tableData, paginationItemCount
    } = props;
    return (
        <div style={{ margin: 'auto', marginTop: '2em', width: '85%', textAlign: 'center'}}>
            <Button
                variant='outline-primary' style={{ display: 'inline', fontSize: '0.7em' }}
                disabled={activePage === 0}
                onClick={handleClickBegin}
            >
                <i className="las la-angle-double-left"></i>
            </Button>{' '}
            <Button
                variant='outline-primary' style={{ display: 'inline', fontSize: '0.7em' }}
                disabled={activePage === 0}
                onClick={handleClickLeft}
            >
                <i className="las la-angle-left"></i>
            </Button>{'  '}
            <p className='paginator-text' style={{ display: 'inline', fontSize: '0.7em' }}>
                Rows{' '}
                {String(activePage * 10 + 1).padStart(String(tableData.length).length, '0')}{' '}
                to{' '}
                {String(Math.min(activePage * 10 + 10, tableData.length)).padStart(String(tableData.length).length, '0')}{' '}
                of{' '}{tableData.length}
            </p>{'  '}
            <Button
                variant='outline-primary' disabled={activePage === paginationItemCount - 1}
                style={{ display: 'inline', fontSize: '0.7em' }}
                onClick={handleClickRight}
            >
                <i className="las la-angle-right"></i>
            </Button>{' '}
            <Button
                variant='outline-primary' style={{ display: 'inline', fontSize: '0.7em' }}
                disabled={activePage === paginationItemCount - 1}
                onClick={handleClickEnd}
            >
                <i className="las la-angle-double-right"></i>
            </Button>
        </div>
    )
}

export default DataBrowsePaginator;